module.exports = __webpack_public_path__ + "static/media/diner.bbef8da6.jpg";